import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { browserHistory } from 'react-router';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { CheckboxField } from '@zola/zola-ui/src/components/Form/CheckboxField';
import { AlertIcon } from '@zola/zola-ui/src/components/SvgIcons';
import { getQRCodeState } from 'cards/selectors/qrCode';
import { getImageUrl } from 'cards/util/imageHelper';
import { updateQRCodeState } from 'cards/actions/qrCode';
import { useLowContrastCheck } from 'cards/hooks/customization/contrast';
import { Box, Title, TextBox, ButtonBox, QRPreviewBox, WarningBanner } from './styles';

const WebsiteOnboard = (): JSX.Element | null => {
  return (
    <Box>
      <Title>Did you select a website template?</Title>
      <TextBox>
        If you finished your wedding website, we will refresh the page for you to update your QR
        code link.
      </TextBox>
      <ButtonBox>
        <ButtonV2
          onClick={() => {
            window?.location?.reload();
          }}
        >
          Yes, Refresh Page
        </ButtonV2>
      </ButtonBox>
    </Box>
  );
};

export interface QRReviewProps {
  hideModalFn(): void;
  nextStepUrl?: string;
}

const QRReview = ({ hideModalFn, nextStepUrl }: QRReviewProps): JSX.Element | null => {
  const [agree, setAgree] = useState(false);
  const qrCodeState = useSelector(getQRCodeState);
  const dispatch = useDispatch();
  const isLowContrast = useLowContrastCheck('FFFFFF', qrCodeState?.color || '000000');

  return (
    <Box>
      <Title>Check that it works</Title>
      <TextBox>
        Scan the code with your device’s camera. Make sure to turn up your screen’s brightness!
      </TextBox>
      <QRPreviewBox>
        <img
          src={qrCodeState?.qrElement?.image_id && getImageUrl(qrCodeState.qrElement.image_id)}
          alt="scan your qr code"
          width="140px"
          height="140px"
        />
        <CheckboxField
          id="qr-code-reviewed"
          label="Tested! Works perfectly 🙌"
          checked={agree}
          onChange={() => setAgree(!agree)}
        />
      </QRPreviewBox>
      {isLowContrast && (
        <WarningBanner>
          <AlertIcon width={24} height={24} /> You selected a QR code color that may not scan well.
        </WarningBanner>
      )}
      <ButtonBox>
        <ButtonV2 variant="secondary" onClick={hideModalFn}>
          Back
        </ButtonV2>
        <ButtonV2
          disabled={!agree}
          onClick={() => {
            if (nextStepUrl) {
              dispatch(updateQRCodeState({ reviewed: true }));
              hideModalFn();
              browserHistory.push(nextStepUrl);
            }
          }}
        >
          All Set
        </ButtonV2>
      </ButtonBox>
    </Box>
  );
};

export default { WebsiteOnboard, QRReview };
